/*
 * @description:
 * @FilePath: /homepage_01/src/router/index.js
 * @author: david
 * @文件版本: V1.0.0
 * @Date: 2025-09-09 14:23:08
 * 版权信息: 2025 by david, All Rights Reserved.
 */
import Vue from "vue";
import Router from "vue-router";
// import home from "@/components/home";
import NewHome from "@/components/NewHome";
import Recruit from "@/components/Recruit";
import RecruitDetail from "@/components/RecruitDetail";
import ActivityDetail from "@/components/ActivityDetail";
import ImageView from "@/components/ImageView";
Vue.use(Router);

export default new Router({
  mode: "hash",
  base: "/", // 这是二级路径
  routes: [
    {
      path: "/",
      name: "home",
      component: NewHome,
    },
    {
      path: "/recruit",
      name: "recruit",
      component: Recruit,
    },
    {
      path: "/recruit-detail",
      name: "recruitDetail",
      component: RecruitDetail,
    },
    {
      path: "/activity-detail",
      name: "activityDetail",
      component: ActivityDetail,
    },
    {
      path: "/image-view",
      name: "imageView",
      component: ImageView,
    },
  ],
});



// WEBPACK FOOTER //
// ./src/router/index.js